import React from 'react';
import {Section, SectionTitle, ListItem, UnorderedList} from 'styles/shared/styled-components';

const Concerts = () => (
  <Section id="concerts">
    <SectionTitle> Concerts (35) </SectionTitle>
    <UnorderedList>
      <ListItem> EUROPE - 🇳🇱</ListItem>
      <ListItem> Alter Bridge - 🇳🇱</ListItem>
      <ListItem> Living Colour - 🇳🇱</ListItem>
      <ListItem> Red Hot Chili Peppers - 🇳🇱</ListItem>
      <ListItem> Tommy Emmanuel - 🇳🇱</ListItem>
      <ListItem> Paul Gilbert - 🇳🇱</ListItem>
      <ListItem> Nickelback - 🇳🇱</ListItem>
      <ListItem> Iron Maiden - 🇨🇿</ListItem>
      <ListItem> ZZ Top - 🇲🇰</ListItem>
      <ListItem> One Republic - 🇲🇰</ListItem>
      <ListItem> Whitesnake - 🇲🇰</ListItem>
      <ListItem> Robbie Williams - 🇷🇸</ListItem>
      <ListItem> Metallica - 🇷🇸</ListItem>
      <ListItem> Whitesnake - 🇷🇸</ListItem>
      <ListItem> Joe Satriani - 🇧🇬</ListItem>
      <ListItem> Scorpions - 🇧🇬</ListItem>
      <ListItem> Queen + Adam Lambert - 🇧🇬</ListItem>
      <ListItem> AC/DC + Axl Rose - 🇦🇹</ListItem>
      <ListItem> Aerosmith - 🇧🇬</ListItem>
      <ListItem> Rolling Stones - 🇩🇪</ListItem>
      <ListItem> Linkin Park - 🇳🇱</ListItem>
      <ListItem> John Mayer - 🇳🇱</ListItem>
      <ListItem> Bryan Adams - 🇳🇱</ListItem>
      <ListItem> Hans Zimmer - 🇳🇱</ListItem>
      <ListItem> Paul Gilbert - 🇳🇱</ListItem>
      <ListItem> Evanescence - 🇳🇱</ListItem>
      <ListItem> Deep Purple - 🇳🇱</ListItem>
      <ListItem> The Piano Guys - 🇳🇱</ListItem>
      <ListItem> Apocalyptica - 🇳🇱</ListItem>
      <ListItem> KISS - 🇳🇱</ListItem>
      <ListItem> The Killers - 🇬🇧</ListItem>
      <ListItem> Guns N' Roses - 🇳🇱</ListItem>
      <ListItem> Inglorious - 🇩🇪 </ListItem>
      <ListItem> Eric Clapton - 🇬🇧 </ListItem>
      <ListItem> Santana - 🇬🇧 </ListItem>
      <ListItem> Gary Clark Jr. - 🇬🇧 </ListItem>
    </UnorderedList>
  </Section>
);

export default Concerts;


// WEBPACK FOOTER //
// ./src/components/sections/Concerts/index.js